import React, { useEffect, useState } from 'react';

const AssociationSpinner = ({ messages = [] }) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [fade, setFade] = useState(false);

  const fadeInFadeOut = () => {
    setFade((prev) => {
      if (!prev) {
        setMessageIndex((idx) =>
          idx + 1 < messages.length ? idx + 1 : 0,
        );
      }
      return !prev;
    });
  };

  useEffect(() => {
    const timer = setTimeout(fadeInFadeOut, 5000);
    return () => clearTimeout(timer);
  }, [fade]);

  return (
    <div className="spinner">
      <div className="spinner__content">
        <div className="spinner__loading" />
        <div
          className={`spinner__text fader ${fade ? '' : 'fadedOut'}`}
        >
          <p>
            <br />
            &shy;
            {messages[messageIndex]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AssociationSpinner;
